var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluePaperclipIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_9259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5V12.5C5 14.157 6.34301 15.5 8 15.5C9.65699 15.5 11 14.157 11 12.5V3.5C11 2.39549 10.1045 1.5 9 1.5C7.89549 1.5 7 2.39549 7 3.5V12.5C7 13.0525 7.448 13.5 8 13.5C8.55251 13.5 9 13.0525 9 12.5V4.5H10V12.5C10 13.6045 9.10451 14.5 8 14.5C6.89549 14.5 6 13.6045 6 12.5V3.5C6 1.84301 7.34301 0.5 9 0.5C10.657 0.5 12 1.84301 12 3.5V13C11.7535 14.9725 10.0395 16.5 8 16.5C5.96051 16.5 4.24651 14.9725 4 13V2.5H5Z",
    fill: "#6A83D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_9259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePaperclipIcon);
export default __webpack_public_path__ + "static/media/blue-paperclip-icon.e1ee3b502764cd26466e0737b5cd5bb2.svg";
export { ForwardRef as ReactComponent };